export default [
  {name: "Afghánistán", code: "af"},
  {name: "Alandy", code: "ax"},
  {name: "Albánie", code: "al"},
  {name: "Alžírsko", code: "dz"},
  {name: "Americká Samoa", code: "as"},
  {name: "Andorra", code: "ad"},
  {name: "Angola", code: "ao"},
  {name: "Anguilla", code: "ai"},
  {name: "Antarktida", code: "aq"},
  {name: "Antigua a Barbuda", code: "ag"},
  {name: "Argentina", code: "ar"},
  {name: "Arménie", code: "am"},
  {name: "Aruba", code: "aw"},
  {name: "Austrálie", code: "au"},
  {name: "Ázerbájdžán", code: "az"},
  {name: "Bahamy", code: "bs"},
  {name: "Bahrajn", code: "bh"},
  {name: "Bangladéš", code: "bd"},
  {name: "Barbados", code: "bb"},
  {name: "Belgie", code: "be"},
  {name: "Belize", code: "bz"},
  {name: "Bělorusko", code: "by"},
  {name: "Benin", code: "bj"},
  {name: "Bermudy", code: "bm"},
  {name: "Bhútán", code: "bt"},
  {name: "Bolívie", code: "bo"},
  {name: "Bosna a Hercegovina", code: "ba"},
  {name: "Botswana", code: "bw"},
  {name: "Bouvetův ostrov", code: "bv"},
  {name: "Brazílie", code: "br"},
  {name: "Brunej", code: "bn"},
  {name: "Bulharsko", code: "bg"},
  {name: "Burkina Faso", code: "bf"},
  {name: "Burundi", code: "bi"},
  {name: "Cookovy ostrovy", code: "ck"},
  {name: "Curaçao", code: "cw"},
  {name: "Čad", code: "td"},
  {name: "Černá Hora", code: "me"},
  {name: "Česko", code: "cz"},
  {name: "Čína", code: "cn"},
  {name: "Dánsko", code: "dk"},
  {name: "Dominika", code: "dm"},
  {name: "Džibutsko", code: "dj"},
  {name: "Egypt", code: "eg"},
  {name: "Ekvádor", code: "ec"},
  {name: "Eritrea", code: "er"},
  {name: "Estonsko", code: "ee"},
  {name: "Etiopie", code: "et"},
  {name: "Faerské ostrovy", code: "fo"},
  {name: "Falklandy (Malvíny)", code: "fk"},
  {name: "Fidži", code: "fj"},
  {name: "Filipíny", code: "ph"},
  {name: "Finsko", code: "fi"},
  {name: "Francie", code: "fr"},
  {name: "Francouzská Guyana", code: "gf"},
  {name: "Gabon", code: "ga"},
  {name: "Gambie", code: "gm"},
  {name: "Ghana", code: "gh"},
  {name: "Gibraltar", code: "gi"},
  {name: "Grenada", code: "gd"},
  {name: "Grónsko", code: "gl"},
  {name: "Gruzie", code: "ge"},
  {name: "Guadeloupe", code: "gp"},
  {name: "Guam", code: "gu"},
  {name: "Guatemala", code: "gt"},
  {name: "Guinea", code: "gn"},
  {name: "Guinea-Bissau", code: "gw"},
  {name: "Guernsey", code: "gg"},
  {name: "Guyana", code: "gy"},
  {name: "Haiti", code: "ht"},
  {name: "Honduras", code: "hn"},
  {name: "Hongkong", code: "hk"},
  {name: "Chile", code: "cl"},
  {name: "Chorvatsko", code: "hr"},
  {name: "Indie", code: "in"},
  {name: "Indonésie", code: "id"},
  {name: "Irák", code: "iq"},
  {name: "Írán", code: "ir"},
  {name: "Irsko", code: "ie"},
  {name: "Island", code: "is"},
  {name: "Itálie", code: "it"},
  {name: "Izrael", code: "il"},
  {name: "Jamajka", code: "jm"},
  {name: "Japonsko", code: "jp"},
  {name: "Jemen", code: "ye"},
  {name: "Jersey", code: "je"},
  {name: "Jižní Korea", code: "kr"},
  {name: "Jižní Súdán", code: "ss"},
  {name: "Jordánsko", code: "jo"},
  {name: "Kajmanské ostrovy", code: "ky"},
  {name: "Kambodža", code: "kh"},
  {name: "Kamerun", code: "cm"},
  {name: "Kanada", code: "ca"},
  {name: "Kapverdy", code: "cv"},
  {name: "Katar", code: "qa"},
  {name: "Kazachstán", code: "kz"},
  {name: "Keňa", code: "ke"},
  {name: "Kiribati", code: "ki"},
  {name: "Kokosové ostrovy", code: "cc"},
  {name: "Kolumbie", code: "co"},
  {name: "Komory", code: "km"},
  {name: "Kongo", code: "cg"},
  {name: "Kostarika", code: "cr"},
  {name: "Kuba", code: "cu"},
  {name: "Kuvajt", code: "kw"},
  {name: "Kypr", code: "cy"},
  {name: "Kyrgyzstán", code: "kg"},
  {name: "Laos", code: "la"},
  {name: "Lesotho", code: "ls"},
  {name: "Libanon", code: "lb"},
  {name: "Libérie", code: "lr"},
  {name: "Libye", code: "ly"},
  {name: "Lichtenštejnsko", code: "li"},
  {name: "Litva", code: "lt"},
  {name: "Lotyšsko", code: "lv"},
  {name: "Lucembursko", code: "lu"},
  {name: "Macao", code: "mo"},
  {name: "Madagaskar", code: "mg"},
  {name: "Maďarsko", code: "hu"},
  {name: "Malajsie", code: "my"},
  {name: "Malawi", code: "mw"},
  {name: "Maledivy", code: "mv"},
  {name: "Mali", code: "ml"},
  {name: "Malta", code: "mt"},
  {name: "Ostrov Man", code: "im"},
  {name: "Maroko", code: "ma"},
  {name: "Marshallovy ostrovy", code: "mh"},
  {name: "Martinik", code: "mq"},
  {name: "Mauricius", code: "mu"},
  {name: "Mauritánie", code: "mr"},
  {name: "Mayotte", code: "yt"},
  {name: "Mexiko", code: "mx"},
  {name: "Mikronésie", code: "fm"},
  {name: "Moldavsko", code: "md"},
  {name: "Monako", code: "mc"},
  {name: "Mongolsko", code: "mn"},
  {name: "Montserrat", code: "ms"},
  {name: "Mosambik", code: "mz"},
  {name: "Myanmar", code: "mm"},
  {name: "Namibie", code: "na"},
  {name: "Nauru", code: "nr"},
  {name: "Německo", code: "de"},
  {name: "Nepál", code: "np"},
  {name: "Niger", code: "ne"},
  {name: "Nigérie", code: "ng"},
  {name: "Nikaragua", code: "ni"},
  {name: "Niue", code: "nu"},
  {name: "Nizozemsko", code: "nl"},
  {name: "Norfolk", code: "nf"},
  {name: "Norsko", code: "no"},
  {name: "Nová Kaledonie", code: "nc"},
  {name: "Nový Zéland", code: "nz"},
  {name: "Omán", code: "om"},
  {name: "Pákistán", code: "pk"},
  {name: "Palau", code: "pw"},
  {name: "Panama", code: "pa"},
  {name: "Papua Nová Guinea", code: "pg"},
  {name: "Paraguay", code: "py"},
  {name: "Peru", code: "pe"},
  {name: "Pitcairnovy ostrovy", code: "pn"},
  {name: "Pobřeží slonoviny", code: "ci"},
  {name: "Polsko", code: "pl"},
  {name: "Portoriko", code: "pr"},
  {name: "Portugalsko", code: "pt"},
  {name: "Rakousko", code: "at"},
  {name: "Réunion", code: "re"},
  {name: "Rovníková Guinea", code: "gq"},
  {name: "Rumunsko", code: "ro"},
  {name: "Rusko", code: "ru"},
  {name: "Rwanda", code: "rw"},
  {name: "Řecko", code: "gr"},
  {name: "Salvador", code: "sv"},
  {name: "Samoa", code: "ws"},
  {name: "San Marino", code: "sm"},
  {name: "Saúdská Arábie", code: "sa"},
  {name: "Senegal", code: "sn"},
  {name: "Severní Korea", code: "kp"},
  {name: "Severní Makedonie", code: "mk"},
  {name: "Severní Mariany", code: "mp"},
  {name: "Seychely", code: "sc"},
  {name: "Sierra Leone", code: "sl"},
  {name: "Singapur", code: "sg"},
  {name: "Slovensko", code: "sk"},
  {name: "Slovinsko", code: "si"},
  {name: "Somálsko", code: "so"},
  {name: "Srbsko", code: "rs"},
  {name: "Srí Lanka", code: "lk"},
  {name: "Súdán", code: "sd"},
  {name: "Surinam", code: "sr"},
  {name: "Svatá Lucie", code: "lc"},
  {name: "Svatý Bartoloměj", code: "bl"},
  {name: "Svazijsko", code: "sz"},
  {name: "Sýrie", code: "sy"},
  {name: "Šalomounovy ostrovy", code: "sb"},
  {name: "Španělsko", code: "es"},
  {name: "Švédsko", code: "se"},
  {name: "Švýcarsko", code: "ch"},
  {name: "Tádžikistán", code: "tj"},
  {name: "Tanzanie", code: "tz"},
  {name: "Thajsko", code: "th"},
  {name: "Tchaj-wan", code: "tw"},
  {name: "Togo", code: "tg"},
  {name: "Tokelau", code: "tk"},
  {name: "Tonga", code: "to"},
  {name: "Trinidad a Tobago", code: "tt"},
  {name: "Tunisko", code: "tn"},
  {name: "Turecko", code: "tr"},
  {name: "Turkmenistán", code: "tm"},
  {name: "Turks a Caicos", code: "tc"},
  {name: "Tuvalu", code: "tv"},
  {name: "Uganda", code: "ug"},
  {name: "Ukrajina", code: "ua"},
  {name: "Uruguay", code: "uy"},
  {name: "Uzbekistán", code: "uz"},
  {name: "Vánoční ostrov", code: "cx"},
  {name: "Vanuatu", code: "vu"},
  {name: "Vatikán", code: "va"},
  {name: "Venezuela", code: "ve"},
  {name: "Vietnam", code: "vn"},
  {name: "Východní Timor", code: "tl"},
  {name: "Wallis a Futuna", code: "wf"},
  {name: "Zambie", code: "zm"},
  {name: "Západní Sahara", code: "eh"},
  {name: "Zimbabwe", code: "zw"}
]
